/** La sentinella, dal lato della pagina. */
import { get } from './api'

export interface Concern {
  /** Nome stabile del tipo: lo stesso dell'etichetta della metrica e della lettera (GI-300). */
  kind: string
  what: string
  detail: string
  first_step: string
}

export interface Watch {
  checked_at: string
  concerns: Concern[]
  jobs_in_flight: number
}

export function look(): Promise<Watch> {
  return get<Watch>('/operations/concerns')
}
